import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { blankComponent } from './blank.component';
import { basicComponent } from './basic.component';
import { NavigationModule } from '../navigation/navigation.module';
import { TopnavbarModule } from '../topnavbar/topnavbar.module';
import { FooterModule } from '../footer/footer.module';
import { HeaderModule } from '../header/header.module';
import { SubHeaderModule } from '../sub-header/sub-header.module';
import { TranslateModule } from '@ngx-translate/core';
import { ConfirmDialogModule } from 'primeng-lts/confirmdialog';



@NgModule({
  declarations: [blankComponent, basicComponent],
  imports: [
    TranslateModule,
    CommonModule,
    RouterModule,
    NavigationModule,
    TopnavbarModule,
    FooterModule,
    HeaderModule,
    SubHeaderModule,
    ConfirmDialogModule
  ],
  exports: [blankComponent, basicComponent]
})
export class LayoutsModule { }
